import React, { Component } from 'react';
import './PostFAQ.css';

/* ---------- Static content (edit here) ---------- */
const TEXT = {
  en: {
    title: 'Good to know about this stay',
    subtitle: 'Common questions for this listing. Anything specific — message the host.',
    seeAll: 'See all FAQs',
    showLess: 'Show less',
  },
  bn: {
    title: 'এই স্টে সম্পর্কে জেনে নিন',
    subtitle: 'এই লিস্টিং নিয়ে সাধারণ প্রশ্ন। নির্দিষ্ট কিছু হলে হোস্টকে মেসেজ করুন।',
    seeAll: 'সব প্রশ্ন দেখুন',
    showLess: 'কম দেখুন',
  },
};

const DEFAULT_ANSWER = {
  en: 'This specific information is already mentioned in the app and website. You are requested to kindly check the listing details. You can also text the host through the app chatbox in case of any confusion or if you need any additional information.',
  bn: 'এই তথ্যটি অ্যাপ ও ওয়েবসাইটে আগে থেকেই দেওয়া আছে। অনুগ্রহ করে লিস্টিংয়ের বিস্তারিত দেখে নিন। কোনো বিভ্রান্তি থাকলে বা অতিরিক্ত তথ্যের প্রয়োজন হলে অ্যাপের চ্যাটবক্সের মাধ্যমে হোস্টকে মেসেজ করতে পারেন।',
};

const FAQ_CATEGORIES = [
  {
    id: 'apartment',
    title: { en: 'Apartment Details', bn: 'এপার্টমেন্ট এর বিস্তারিত' },
    items: [
      { q: { en: 'Is it a full apartment or a private room?', bn: 'এটি কি পুরো এপার্টমেন্ট নাকি প্রাইভেট রুম?' } },
      { q: { en: 'Will there be anyone else in the apartment?', bn: 'এপার্টমেন্টে কি অন্য কেউ থাকবেন?' } },
      { q: { en: 'Is there an AC or attached washroom?', bn: 'এসি বা অ্যাটাচ্ড ওয়াশরুম আছে কি?' } },
      { q: { en: 'Are there kitchen facilities available? Can I cook?', bn: 'রান্নাঘরের সুবিধা আছে কি? আমি কি রান্না করতে পারব?' } },
    ],
  },
  {
    id: 'checkin',
    title: { en: 'NID & Check-In Process', bn: 'ডকুমেন্ট এবং চেক-ইন প্রক্রিয়া' },
    items: [
      { q: { en: 'Which documents are required at check-in?', bn: 'চেক-ইনের সময় কোন কোন ডকুমেন্ট লাগবে?' } },
      { q: { en: 'Can I check in earlier or check out later?', bn: 'আমি কি আগে চেক-ইন বা পরে চেক-আউট করতে পারব?' } },
      { q: { en: 'How will I get the keys?', bn: 'আমি চাবি কীভাবে পাব?' } },
    ],
  },
  {
    id: 'payment',
    title: { en: 'Payment & Price', bn: 'পেমেন্ট এবং প্রাইস সংক্রান্ত' },
    items: [
      { q: { en: 'When do I need to pay?', bn: 'কখন পেমেন্ট করতে হবে?' } },
      { q: { en: 'Which payment methods are accepted?', bn: 'কোন কোন পেমেন্ট পদ্ধতি গ্রহণযোগ্য?' } },
      { q: { en: 'Are there any extra charges?', bn: 'কোনো অতিরিক্ত চার্জ আছে কি?' } },
    ],
  },
  {
    id: 'location',
    title: { en: 'Location & Accessibility', bn: 'লোকেশন এবং সুবিধাসমূহ' },
    items: [
      { q: { en: 'How do I reach the property?', bn: 'প্রপার্টিতে কীভাবে পৌঁছাব?' } },
      { q: { en: 'Is parking available?', bn: 'পার্কিংয়ের সুবিধা আছে কি?' } },
      { q: { en: 'Are there shops or restaurants nearby?', bn: 'কাছাকাছি দোকান বা রেস্টুরেন্ট আছে কি?' } },
    ],
  },
];

class PostFAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: 'en',
      openCategory: null, // category id, or 'all'
      openQuestion: null, // `${categoryId}-${index}`
    };
  }

  setLang = (lang) => this.setState({ lang });

  toggleCategory = (id) => {
    this.setState(p => {
      const isOpen = p.openCategory === id || p.openCategory === 'all';
      return {
        openCategory: isOpen ? null : id,
        openQuestion: isOpen ? null : `${id}-0`,
      };
    });
  };

  toggleQuestion = (key) => {
    this.setState(p => ({ openQuestion: p.openQuestion === key ? null : key }));
  };

  toggleAll = () => {
    this.setState(p => ({
      openCategory: p.openCategory === 'all' ? null : 'all',
      openQuestion: null,
    }));
  };

  render() {
    
    const { lang, openCategory, openQuestion } = this.state;
    const t = TEXT[lang];
    const allOpen = openCategory === 'all';

    return (
      <section className="faq-section" lang={lang === 'bn' ? 'bn' : 'en'}>
        <div className="faq-header">
          <div className="faq-header-copy">
            <h3 className="faq-title">{t.title}</h3>
            <p className="faq-subtitle">{t.subtitle}</p>
          </div>

          <div className="faq-lang-toggle" role="group" aria-label="Language">
            <button
              type="button"
              className={lang === 'en' ? 'is-active' : ''}
              aria-pressed={lang === 'en'}
              onClick={() => this.setLang('en')}
            >
              EN
            </button>
            <button
              type="button"
              className={lang === 'bn' ? 'is-active' : ''}
              aria-pressed={lang === 'bn'}
              onClick={() => this.setLang('bn')}
            >
              বাং
            </button>
          </div>
        </div>

        <div className="faq-categories">
          {FAQ_CATEGORIES.map(({ id, title, items }) => {
            const isOpen = allOpen || openCategory === id;

            return (
              <div className={`faq-category ${isOpen ? 'is-open' : ''}`} key={id}>
                <button
                  type="button"
                  className="faq-category-head"
                  aria-expanded={isOpen}
                  onClick={() => this.toggleCategory(id)}
                >
                  <span className="faq-category-title">{title[lang]}</span>
                  <span className="faq-category-line" />
                  <span className="faq-category-count">{items.length}</span>
                  <span className="faq-category-toggle"><i className="fas fa-caret-down" /></span>
                </button>

                <div className="faq-collapse">
                  <div className="faq-collapse-inner">
                    <div className="faq-question-list">
                      {items.map((item, index) => {
                        const key = `${id}-${index}`;
                        const isQuestionOpen = openQuestion === key;

                        return (
                          <div className={`faq-question ${isQuestionOpen ? 'is-open' : ''}`} key={key}>
                            <button
                              type="button"
                              className="faq-question-head"
                              aria-expanded={isQuestionOpen}
                              onClick={() => this.toggleQuestion(key)}
                            >
                              <span className="faq-question-number">{String(index + 1).padStart(2, '0')}</span>
                              <span className="faq-question-text">{item.q[lang]}</span>
                              <span className="faq-question-toggle" aria-hidden="true">+</span>
                            </button>

                            <div className="faq-collapse">
                              <div className="faq-collapse-inner">
                                <p className="faq-answer">{item.a ? item.a[lang] : DEFAULT_ANSWER[lang]}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <button type="button" className="faq-see-all" onClick={this.toggleAll}>
          <span>{allOpen ? t.showLess : t.seeAll}</span>
          <i className={`fas fa-long-arrow-alt-${allOpen ? 'up' : 'right'}`} />
        </button>
      </section>
    );
  }
}

export default PostFAQ;
